// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.2.4 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

/*
NOTE: Inter font:
- Defined in HTML template for easy toggling of static() path in trinity & prod (CDN).
- To save bandwidth, do not include variable italic form.
- Experimental version with oblique style for italic is too experimental.
- To save bandwidth, only latin characters are loaded (70KB vs 318KB).
- Font preload added to HTML template.
*/

/*
These overrides match bootstrap's reset since a lot of styling was developed
assumings its reset values.
*/
svg {
  display: inline;
}

a {
  --tw-text-opacity: 1;
  color: rgb(27 149 224 / var(--tw-text-opacity));
}

a:hover {
  text-decoration-line: underline;
}

p {
  margin-bottom: 1rem;
}

/*
QUICK FIX: Without this, <input> forces fieldset to expand beyond its parent
container. This, however, doesn't appear to be a common problem (when searching
for reasons for this) so it's unclear why 'auto' isn't the default.
*/
fieldset {
  min-inline-size: auto;
}

/* stylelint-disable custom-property-pattern, function-no-unknown */
.mdx-editor-container-dark {
  --accentText: #1b95e0 !important;
  --baseBg: #27272a !important; /* Equivalent to bg-highlight */
  --basePageBg: #1a1a1d !important; /* Equivalent to bg-primary */
  --baseBgHover: #333 !important;
  --accentBorder: #990299 !important;
  --accentSolidHover: #990299 !important;
  --baseText: #e2e8f0 !important;
}

.mdx-editor-container-light {
  --accentBorder: #800080 !important;
  --accentSolidHover: #800080 !important;
  --accentText: #1b95e0 !important;
  --baseBg: #f7f7f7 !important; /* Equivalent to bg-highlight */
  --basePageBg: #fefefe !important; /* Equivalent to bg-primary */
}
/* stylelint-enable custom-property-pattern, function-no-unknown */

.mdx-editor-content {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-dark .mdx-editor-content {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}

.mdx-editor-content {
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 0.625rem;
}

.mdx-editor-content blockquote {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}

.tw-dark .mdx-editor-content blockquote {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

.mdx-editor-content blockquote {
  margin-left: 2px;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2rem;
  padding-right: 0.5rem;
  border-radius: 0.5rem;
  border-left-width: 4px;
  --tw-border-opacity: 1;
  border-left-color: rgb(33 37 41 / var(--tw-border-opacity));
}

.tw-dark .mdx-editor-content blockquote {
  --tw-border-opacity: 1;
  border-left-color: rgb(226 232 240 / var(--tw-border-opacity));
}

.mdx-editor-content h1,
  .mdx-editor-content h2,
  .mdx-editor-content h3,
  .mdx-editor-content h4,
  .mdx-editor-content h5,
  .mdx-editor-content h6 {
  margin-top: 1rem;
}

.mdx-editor-content h1:first-child,
  .mdx-editor-content h2:first-child,
  .mdx-editor-content h3:first-child,
  .mdx-editor-content h4:first-child,
  .mdx-editor-content h5:first-child,
  .mdx-editor-content h6:first-child {
  margin-top: 0px;
}

.mdx-editor-content h1 {
  font-size: 1.3rem;
  font-weight: 700;
}

.mdx-editor-content h2 {
  font-size: 1.25rem;
  font-weight: 700;
}

.mdx-editor-content h3 {
  font-size: 1.2rem;
  font-weight: 700;
}

.mdx-editor-content h4 {
  font-size: 1.15rem;
  font-weight: 700;
}

.mdx-editor-content h5 {
  font-size: 1.10rem;
  font-weight: 600;
}

.mdx-editor-content h6 {
  font-size: 1.05rem;
  font-weight: 600;
}

.mdx-editor-content ol {
  list-style-position: outside;
  list-style-type: decimal;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.mdx-editor-content ul {
  list-style-position: outside;
  list-style-type: disc;
  padding-left: 1.25rem;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.mdx-editor-content li {
  margin-top: 0px;
  margin-bottom: 0px;
}

.mdx-editor-content li>ul {
  padding-left: 1.25rem;
}

.mdx-editor-content li>ol {
  padding-left: 1.25rem;
}

.mdx-editor-content p {
  margin-bottom: 0px;
}

.mdx-editor-content .cm-editor {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
  overflow-x: scroll;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
  padding: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  line-height: 1.25;
}

.tw-container {
  width: 100%;
}

@media (min-width: 640px) {

  .tw-container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {

  .tw-container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {

  .tw-container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {

  .tw-container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {

  .tw-container {
    max-width: 1536px;
  }
}

/*
   * Scrollbar
   * The primary goal is to customize the horizontal scrollbar for horizontal
   * feeds as the default is too ugly to bear.
  */

/*
    Firefox only

    Styles are disabled for chrome/webkit because if they're specified they
    take priority. See:

    https://syntackle.com/blog/changes-to-scrollbar-styling-in-chrome-121/

  */

@supports not selector(::-webkit-scrollbar) {
  .ff-scrollbar {
      scrollbar-color: #888 transparent;
      scrollbar-width: thin
  }
    }

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
  }

::-webkit-scrollbar-track {
    background: transparent;
  }

::-webkit-scrollbar-thumb {
    background: #888;
  }

.modal-scrollbar::-webkit-scrollbar-thumb {
    background: #444;
  }

.modal-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #333;
  }

.tw-dark ::-webkit-scrollbar-thumb {
    background: #777;
  }

::-webkit-scrollbar-thumb:hover {
    background: #444;
  }

.tw-dark ::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }

/*
   * Other styles
   */

.tw-text-primary {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-dark .tw-text-primary {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}

.tw-text-primary-inverted {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}

.tw-dark .tw-text-primary-inverted {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-text-light {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity));
}

.tw-text-dark {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}

.tw-text-muted {
  --tw-text-opacity: 1;
  color: rgb(105 105 115 / var(--tw-text-opacity));
}

.tw-dark .tw-text-muted {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}

.tw-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}

.tw-dark .tw-bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 29 / var(--tw-bg-opacity));
}

.tw-bg-primary-inverted {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 29 / var(--tw-bg-opacity));
}

.tw-dark .tw-bg-primary-inverted {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}

.tw-bg-highlight {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}

.tw-dark .tw-bg-highlight {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

.tw-bg-highlight-inverted {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}

.tw-dark .tw-bg-highlight-inverted {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}

.tw-bg-striped-light {
    background-image: linear-gradient(
      45deg,
      #f5f5f5 25%,
      #f0f0f0 25%,
      #f0f0f0 50%,
      #f5f5f5 50%,
      #f5f5f5 75%,
      #f0f0f0 75%,
      #f0f0f0 100%
    );
    background-size: 56.57px 56.57px;
  }

.tw-bg-canvas {
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity));
}

.tw-dark .tw-bg-canvas {
  --tw-bg-opacity: 1;
  background-color: rgb(19 19 19 / var(--tw-bg-opacity));
}

.tw-link {
  --tw-text-opacity: 1;
  color: rgb(27 149 224 / var(--tw-text-opacity));
}

@media (hover: hover) and (pointer: fine) {

  .tw-link:hover {
    text-decoration-line: underline;
  }
}

.tw-youtube-container-portrait {
    height: max(min(80vh, 700px), 300px);
  }

/*
   * Legacy styling for keyboard highlight bars
   */

/* NA = keyboard selection is not applicable */

.kb-pad-4-na {
  border-width: 1px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 4px;
  border-right-width: 0px;
  border-style: solid;
  border-left-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
}

.kb-pad-4 {
  border-width: 1px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 4px;
  border-right-width: 0px;
  border-style: solid;
  border-left-color: transparent;
  padding-left: 1rem;
  padding-right: 1rem;
}

.kb-pad-4.kb-sel {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(128 0 128 / var(--tw-border-opacity)) !important;
}

.tw-dark .kb-pad-4.kb-sel {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(153 2 153 / var(--tw-border-opacity)) !important;
}

.kb-bar {
  border-width: 1px;
  border-top-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 3px;
  border-right-width: 0px;
  border-style: solid;
  border-left-color: transparent;
}

.kb-bar.kb-sel {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(128 0 128 / var(--tw-border-opacity)) !important;
}

.tw-dark .kb-bar.kb-sel {
  --tw-border-opacity: 1 !important;
  border-left-color: rgb(153 2 153 / var(--tw-border-opacity)) !important;
}

/*
  * Select styling
  */

.tw-select-arrow {
    background-image: linear-gradient(45deg, transparent 50%, currentcolor 50%),
      linear-gradient(135deg, currentcolor 50%, transparent 50%);
    background-position:
      calc(100% - 20px) calc(1px + 50%),
      calc(100% - 16px) calc(1px + 50%);
    background-repeat: no-repeat;
    background-size:
      4px 4px,
      4px 4px;
  }
.tw-invisible {
  visibility: hidden;
}
.tw-fixed {
  position: fixed;
}
.tw-absolute {
  position: absolute;
}
.tw-relative {
  position: relative;
}
.tw-sticky {
  position: sticky;
}
.tw-top-1 {
  top: 0.25rem;
}
.tw-left-1 {
  left: 0.25rem;
}
.tw-left-0 {
  left: 0px;
}
.tw-top-0 {
  top: 0px;
}
.tw-bottom-0 {
  bottom: 0px;
}
.tw-bottom-2 {
  bottom: 0.5rem;
}
.tw-right-6 {
  right: 1.5rem;
}
.tw-top-\\[2px\\] {
  top: 2px;
}
.tw-right-\\[2px\\] {
  right: 2px;
}
.tw-bottom-16 {
  bottom: 4rem;
}
.tw-right-16 {
  right: 4rem;
}
.tw-right-12 {
  right: 3rem;
}
.tw-top-\\[35\\%\\] {
  top: 35%;
}
.tw-left-\\[25px\\] {
  left: 25px;
}
.tw-left-1\\/2 {
  left: 50%;
}
.tw-right-0 {
  right: 0px;
}
.tw-top-0\\.5 {
  top: 0.125rem;
}
.tw-left-2 {
  left: 0.5rem;
}
.tw-top-\\[calc\\(50\\%-5rem\\)\\] {
  top: calc(50% - 5rem);
}
.tw-right-2 {
  right: 0.5rem;
}
.tw-top-\\[7rem\\] {
  top: 7rem;
}
.tw-top-12 {
  top: 3rem;
}
.tw-top-\\[0\\.125rem\\] {
  top: 0.125rem;
}
.tw-left-\\[0\\.25rem\\] {
  left: 0.25rem;
}
.-tw-left-\\[1\\.6rem\\] {
  left: -1.6rem;
}
.-tw-top-1 {
  top: -0.25rem;
}
.tw-top-\\[-3px\\] {
  top: -3px;
}
.tw-bottom-4 {
  bottom: 1rem;
}
.tw-left-4 {
  left: 1rem;
}
.tw-right-4 {
  right: 1rem;
}
.tw-top-1\\/2 {
  top: 50%;
}
.-tw-top-\\[0\\.09em\\] {
  top: -0.09em;
}
.-tw-top-\\[0\\.08em\\] {
  top: -0.08em;
}
.tw-top-2 {
  top: 0.5rem;
}
.tw-top-\\[10vh\\] {
  top: 10vh;
}
.\\!tw-z-\\[49\\] {
  z-index: 49 !important;
}
.tw-z-\\[1020\\] {
  z-index: 1020;
}
.tw-z-10 {
  z-index: 10;
}
.tw-z-50 {
  z-index: 50;
}
.tw-z-\\[4\\] {
  z-index: 4;
}
.tw-z-20 {
  z-index: 20;
}
.\\!tw-z-\\[100\\] {
  z-index: 100 !important;
}
.tw-z-\\[1070\\] {
  z-index: 1070;
}
.tw-z-\\[-1\\] {
  z-index: -1;
}
.tw-z-\\[52\\] {
  z-index: 52;
}
.tw-z-\\[51\\] {
  z-index: 51;
}
.tw-col-span-1 {
  grid-column: span 1 / span 1;
}
.tw-col-span-2 {
  grid-column: span 2 / span 2;
}
.tw-col-span-12 {
  grid-column: span 12 / span 12;
}
.tw-col-span-4 {
  grid-column: span 4 / span 4;
}
.tw-my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.tw-my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.tw-my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.\\!tw-my-12 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}
.tw-my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.tw-mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.tw-mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.tw-my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.\\!tw-my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}
.tw-my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.tw-mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}
.\\!tw-my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.tw-mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.\\!tw-my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}
.\\!tw-my-10 {
  margin-top: 2.5rem !important;
  margin-bottom: 2.5rem !important;
}
.tw-mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.tw-my-\\[3rem\\] {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.tw-mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.tw-mb-0 {
  margin-bottom: 0px;
}
.\\!tw-mb-6 {
  margin-bottom: 1.5rem !important;
}
.tw-mb-4 {
  margin-bottom: 1rem;
}
.tw-mt-4 {
  margin-top: 1rem;
}
.tw-mb-6 {
  margin-bottom: 1.5rem;
}
.tw-mt-10 {
  margin-top: 2.5rem;
}
.tw-ml-1 {
  margin-left: 0.25rem;
}
.tw-mb-2 {
  margin-bottom: 0.5rem;
}
.tw-mt-2 {
  margin-top: 0.5rem;
}
.tw-mr-1 {
  margin-right: 0.25rem;
}
.tw-ml-6 {
  margin-left: 1.5rem;
}
.tw-mt-3 {
  margin-top: 0.75rem;
}
.tw-mr-2 {
  margin-right: 0.5rem;
}
.tw-mt-6 {
  margin-top: 1.5rem;
}
.tw-ml-2 {
  margin-left: 0.5rem;
}
.tw-mr-4 {
  margin-right: 1rem;
}
.tw-ml-4 {
  margin-left: 1rem;
}
.tw-mt-8 {
  margin-top: 2rem;
}
.tw-mt-1 {
  margin-top: 0.25rem;
}
.tw-mt-0 {
  margin-top: 0px;
}
.tw-mt-12 {
  margin-top: 3rem;
}
.tw-mb-12 {
  margin-bottom: 3rem;
}
.tw-ml-\\[2px\\] {
  margin-left: 2px;
}
.tw-mr-5 {
  margin-right: 1.25rem;
}
.\\!tw-mt-2 {
  margin-top: 0.5rem !important;
}
.\\!tw-mb-0 {
  margin-bottom: 0px !important;
}
.tw-mb-3 {
  margin-bottom: 0.75rem;
}
.tw-mb-1 {
  margin-bottom: 0.25rem;
}
.tw-mb-8 {
  margin-bottom: 2rem;
}
.tw-mr-\\[2px\\] {
  margin-right: 2px;
}
.tw-mr-\\[4px\\] {
  margin-right: 4px;
}
.\\!tw-mt-0 {
  margin-top: 0px !important;
}
.-tw-mt-1 {
  margin-top: -0.25rem;
}
.-tw-mt-0\\.5 {
  margin-top: -0.125rem;
}
.-tw-mt-0 {
  margin-top: -0px;
}
.tw-mt-\\[0\\.1rem\\] {
  margin-top: 0.1rem;
}
.tw-mr-1\\.5 {
  margin-right: 0.375rem;
}
.tw-mr-6 {
  margin-right: 1.5rem;
}
.tw-ml-3 {
  margin-left: 0.75rem;
}
.\\!tw-mt-6 {
  margin-top: 1.5rem !important;
}
.tw-mb-5 {
  margin-bottom: 1.25rem;
}
.tw-ml-5 {
  margin-left: 1.25rem;
}
.\\!tw-mb-4 {
  margin-bottom: 1rem !important;
}
.-tw-ml-2 {
  margin-left: -0.5rem;
}
.tw-mb-\\[20px\\] {
  margin-bottom: 20px;
}
.tw-mb-\\[6px\\] {
  margin-bottom: 6px;
}
.tw-mt-\\[-0\\.125em\\] {
  margin-top: -0.125em;
}
.tw-mt-\\[-1px\\] {
  margin-top: -1px;
}
.tw-mt-\\[5vh\\] {
  margin-top: 5vh;
}
.-tw-ml-8 {
  margin-left: -2rem;
}
.-tw-mt-3 {
  margin-top: -0.75rem;
}
.tw-block {
  display: block;
}
.tw-inline-block {
  display: inline-block;
}
.tw-inline {
  display: inline;
}
.tw-flex {
  display: flex;
}
.tw-inline-flex {
  display: inline-flex;
}
.tw-grid {
  display: grid;
}
.tw-hidden {
  display: none;
}
.tw-aspect-\\[9\\/16\\] {
  aspect-ratio: 9/16;
}
.tw-aspect-video {
  aspect-ratio: 16 / 9;
}
.tw-h-full {
  height: 100%;
}
.tw-h-\\[6px\\] {
  height: 6px;
}
.tw-h-0 {
  height: 0px;
}
.\\!tw-h-full {
  height: 100% !important;
}
.tw-h-\\[1\\.6rem\\] {
  height: 1.6rem;
}
.tw-h-\\[2px\\] {
  height: 2px;
}
.tw-h-\\[1\\.35rem\\] {
  height: 1.35rem;
}
.tw-h-16 {
  height: 4rem;
}
.tw-h-14 {
  height: 3.5rem;
}
.tw-h-10 {
  height: 2.5rem;
}
.tw-h-\\[250px\\] {
  height: 250px;
}
.tw-h-\\[30px\\] {
  height: 30px;
}
.tw-h-\\[36px\\] {
  height: 36px;
}
.tw-h-\\[120px\\] {
  height: 120px;
}
.tw-h-\\[8px\\] {
  height: 8px;
}
.tw-h-4 {
  height: 1rem;
}
.tw-h-6 {
  height: 1.5rem;
}
.tw-h-\\[32px\\] {
  height: 32px;
}
.tw-h-\\[5rem\\] {
  height: 5rem;
}
.tw-h-\\[2rem\\] {
  height: 2rem;
}
.tw-h-1\\/2 {
  height: 50%;
}
.tw-h-\\[12px\\] {
  height: 12px;
}
.tw-h-\\[4px\\] {
  height: 4px;
}
.tw-h-screen {
  height: 100vh;
}
.tw-h-\\[90vh\\] {
  height: 90vh;
}
.tw-h-5 {
  height: 1.25rem;
}
.tw-max-h-\\[90vh\\] {
  max-height: 90vh;
}
.tw-max-h-\\[700px\\] {
  max-height: 700px;
}
.tw-max-h-\\[500px\\] {
  max-height: 500px;
}
.tw-max-h-\\[190px\\] {
  max-height: 190px;
}
.tw-max-h-\\[140px\\] {
  max-height: 140px;
}
.tw-max-h-\\[16rem\\] {
  max-height: 16rem;
}
.tw-max-h-\\[400px\\] {
  max-height: 400px;
}
.tw-max-h-\\[300px\\] {
  max-height: 300px;
}
.tw-max-h-\\[12rem\\] {
  max-height: 12rem;
}
.tw-max-h-80 {
  max-height: 20rem;
}
.\\!tw-min-h-\\[1\\.75rem\\] {
  min-height: 1.75rem !important;
}
.tw-min-h-0 {
  min-height: 0px;
}
.\\!tw-min-h-\\[calc\\(1\\.75rem-4px\\)\\] {
  min-height: calc(1.75rem - 4px) !important;
}
.tw-min-h-\\[20rem\\] {
  min-height: 20rem;
}
.tw-min-h-screen {
  min-height: 100vh;
}
.tw-min-h-\\[1\\.75rem\\] {
  min-height: 1.75rem;
}
.tw-min-h-\\[2\\.5rem\\] {
  min-height: 2.5rem;
}
.tw-w-full {
  width: 100%;
}
.tw-w-\\[4px\\] {
  width: 4px;
}
.tw-w-0 {
  width: 0px;
}
.tw-w-auto {
  width: auto;
}
.tw-w-40 {
  width: 10rem;
}
.tw-w-\\[210px\\] {
  width: 210px;
}
.tw-w-\\[270px\\] {
  width: 270px;
}
.tw-w-\\[2px\\] {
  width: 2px;
}
.tw-w-\\[4\\.5rem\\] {
  width: 4.5rem;
}
.tw-w-16 {
  width: 4rem;
}
.tw-w-14 {
  width: 3.5rem;
}
.tw-w-\\[30px\\] {
  width: 30px;
}
.tw-w-\\[36px\\] {
  width: 36px;
}
.tw-w-\\[120px\\] {
  width: 120px;
}
.tw-w-\\[90\\%\\] {
  width: 90%;
}
.\\!tw-w-full {
  width: 100% !important;
}
.tw-w-\\[20px\\] {
  width: 20px;
}
.tw-w-4 {
  width: 1rem;
}
.tw-w-\\[8px\\] {
  width: 8px;
}
.tw-w-10 {
  width: 2.5rem;
}
.tw-w-6 {
  width: 1.5rem;
}
.tw-w-\\[5rem\\] {
  width: 5rem;
}
.tw-w-\\[2rem\\] {
  width: 2rem;
}
.tw-w-\\[320px\\] {
  width: 320px;
}
.tw-w-screen {
  width: 100vw;
}
.tw-w-5 {
  width: 1.25rem;
}
.tw-w-1\\/2 {
  width: 50%;
}
.tw-w-\\[3\\.5rem\\] {
  width: 3.5rem;
}
.tw-w-\\[10px\\] {
  width: 10px;
}
.\\!tw-min-w-\\[2\\.5rem\\] {
  min-width: 2.5rem !important;
}
.tw-min-w-\\[22rem\\] {
  min-width: 22rem;
}
.tw-min-w-\\[0\\.7rem\\] {
  min-width: 0.7rem;
}
.tw-min-w-\\[40\\%\\] {
  min-width: 40%;
}
.tw-min-w-\\[1\\.25em\\] {
  min-width: 1.25em;
}
.\\!tw-max-w-\\[4\\.5rem\\] {
  max-width: 4.5rem !important;
}
.tw-max-w-\\[30rem\\] {
  max-width: 30rem;
}
.tw-max-w-md {
  max-width: 28rem;
}
.tw-max-w-sm {
  max-width: 24rem;
}
.tw-max-w-full {
  max-width: 100%;
}
.tw-max-w-\\[16rem\\] {
  max-width: 16rem;
}
.tw-max-w-\\[190px\\] {
  max-width: 190px;
}
.\\!tw-max-w-fit {
  max-width: -moz-fit-content !important;
  max-width: fit-content !important;
}
.tw-max-w-\\[10rem\\] {
  max-width: 10rem;
}
.tw-max-w-\\[8rem\\] {
  max-width: 8rem;
}
.tw-max-w-\\[180px\\] {
  max-width: 180px;
}
.tw-max-w-\\[90\\%\\] {
  max-width: 90%;
}
.tw-flex-1 {
  flex: 1 1 0%;
}
.tw-flex-initial {
  flex: 0 1 auto;
}
.tw-shrink-0 {
  flex-shrink: 0;
}
.tw-shrink {
  flex-shrink: 1;
}
.tw-flex-grow {
  flex-grow: 1;
}
.tw-grow {
  flex-grow: 1;
}
.tw-table-auto {
  table-layout: auto;
}
.-tw-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-tw-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tw-transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes tw-spin {

  to {
    transform: rotate(360deg);
  }
}
.tw-animate-spin {
  animation: tw-spin 1s linear infinite;
}
.tw-cursor-pointer {
  cursor: pointer;
}
.tw-cursor-zoom-in {
  cursor: zoom-in;
}
.tw-cursor-auto {
  cursor: auto;
}
.tw-cursor-default {
  cursor: default;
}
.tw-select-none {
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
}
.tw-list-inside {
  list-style-position: inside;
}
.tw-list-outside {
  list-style-position: outside;
}
.tw-list-disc {
  list-style-type: disc;
}
.tw-list-decimal {
  list-style-type: decimal;
}
.tw-appearance-none {
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
}
.tw-grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.tw-grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.tw-grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.tw-grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.tw-flex-row {
  flex-direction: row;
}
.tw-flex-row-reverse {
  flex-direction: row-reverse;
}
.tw-flex-col {
  flex-direction: column;
}
.tw-flex-col-reverse {
  flex-direction: column-reverse;
}
.tw-flex-wrap {
  flex-wrap: wrap;
}
.tw-flex-nowrap {
  flex-wrap: nowrap;
}
.tw-items-start {
  align-items: flex-start;
}
.tw-items-end {
  align-items: flex-end;
}
.tw-items-center {
  align-items: center;
}
.tw-items-stretch {
  align-items: stretch;
}
.tw-justify-start {
  justify-content: flex-start;
}
.tw-justify-end {
  justify-content: flex-end;
}
.tw-justify-center {
  justify-content: center;
}
.tw-justify-between {
  justify-content: space-between;
}
.tw-justify-around {
  justify-content: space-around;
}
.tw-justify-evenly {
  justify-content: space-evenly;
}
.tw-gap-6 {
  gap: 1.5rem;
}
.tw-gap-2 {
  gap: 0.5rem;
}
.tw-gap-4 {
  gap: 1rem;
}
.tw-gap-3 {
  gap: 0.75rem;
}
.tw-gap-1 {
  gap: 0.25rem;
}
.tw-gap-x-2 {
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}
.tw-gap-y-4 {
  row-gap: 1rem;
}
.tw-gap-y-8 {
  row-gap: 2rem;
}
.tw-gap-y-3 {
  row-gap: 0.75rem;
}
.tw-gap-y-2 {
  row-gap: 0.5rem;
}
.tw-gap-y-1 {
  row-gap: 0.25rem;
}
.tw-gap-y-6 {
  row-gap: 1.5rem;
}
.tw-gap-x-4 {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}
.tw-gap-x-1 {
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}
.tw-gap-x-8 {
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}
.tw-self-end {
  align-self: flex-end;
}
.tw-self-center {
  align-self: center;
}
.tw-overflow-hidden {
  overflow: hidden;
}
.tw-overflow-x-auto {
  overflow-x: auto;
}
.tw-overflow-x-hidden {
  overflow-x: hidden;
}
.tw-overflow-y-hidden {
  overflow-y: hidden;
}
.tw-overflow-x-scroll {
  overflow-x: scroll;
}
.tw-overflow-y-scroll {
  overflow-y: scroll;
}
.tw-overscroll-x-none {
  overscroll-behavior-x: none;
}
.tw-text-ellipsis {
  text-overflow: ellipsis;
}
.tw-whitespace-normal {
  white-space: normal;
}
.tw-whitespace-nowrap {
  white-space: nowrap;
}
.tw-whitespace-pre-wrap {
  white-space: pre-wrap;
}
.tw-break-words {
  overflow-wrap: break-word;
}
.tw-break-all {
  word-break: break-all;
}
.tw-rounded {
  border-radius: 0.25rem;
}
.tw-rounded-md {
  border-radius: 0.375rem;
}
.tw-rounded-lg {
  border-radius: 0.5rem;
}
.tw-rounded-sm {
  border-radius: 0.125rem;
}
.tw-rounded-\\[1px\\] {
  border-radius: 1px;
}
.\\!tw-rounded-lg {
  border-radius: 0.5rem !important;
}
.tw-rounded-full {
  border-radius: 9999px;
}
.tw-rounded-2xl {
  border-radius: 1rem;
}
.tw-rounded-none {
  border-radius: 0px;
}
.tw-rounded-3xl {
  border-radius: 1.5rem;
}
.tw-rounded-r-none {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.tw-rounded-l-none {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.tw-rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.tw-rounded-r-sm {
  border-top-right-radius: 0.125rem;
  border-bottom-right-radius: 0.125rem;
}
.tw-rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.tw-rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.tw-rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}
.\\!tw-border {
  border-width: 1px !important;
}
.tw-border {
  border-width: 1px;
}
.tw-border-\\[10px\\] {
  border-width: 10px;
}
.tw-border-2 {
  border-width: 2px;
}
.tw-border-0 {
  border-width: 0px;
}
.tw-border-y-0 {
  border-top-width: 0px;
  border-bottom-width: 0px;
}
.tw-border-x-0 {
  border-left-width: 0px;
  border-right-width: 0px;
}
.tw-border-l-4 {
  border-left-width: 4px;
}
.tw-border-b {
  border-bottom-width: 1px;
}
.tw-border-l {
  border-left-width: 1px;
}
.tw-border-r-0 {
  border-right-width: 0px;
}
.\\!tw-border-t-0 {
  border-top-width: 0px !important;
}
.tw-border-b-0 {
  border-bottom-width: 0px;
}
.tw-border-l-0 {
  border-left-width: 0px;
}
.tw-border-t-0 {
  border-top-width: 0px;
}
.tw-border-l-2 {
  border-left-width: 2px;
}
.tw-border-t-2 {
  border-top-width: 2px;
}
.tw-border-l-\\[4px\\] {
  border-left-width: 4px;
}
.tw-border-r-\\[calc\\(0\\.5rem-4px\\)\\] {
  border-right-width: calc(0.5rem - 4px);
}
.tw-border-solid {
  border-style: solid;
}
.tw-border-dashed {
  border-style: dashed;
}
.\\!tw-border-layout-line-light {
  --tw-border-opacity: 1 !important;
  border-color: rgb(224 224 224 / var(--tw-border-opacity)) !important;
}
.tw-border-layout-line-dark {
  --tw-border-opacity: 1;
  border-color: rgb(55 55 55 / var(--tw-border-opacity));
}
.tw-border-layout-line-light {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.tw-border-perpul-light {
  --tw-border-opacity: 1;
  border-color: rgb(128 0 128 / var(--tw-border-opacity));
}
.tw-border-transparent {
  border-color: transparent;
}
.tw-border-\\[\\#16a34a\\] {
  --tw-border-opacity: 1;
  border-color: rgb(22 163 74 / var(--tw-border-opacity));
}
.tw-border-\\[\\#ff0000\\] {
  --tw-border-opacity: 1;
  border-color: rgb(255 0 0 / var(--tw-border-opacity));
}
.tw-border-\\[\\#858585\\] {
  --tw-border-opacity: 1;
  border-color: rgb(133 133 133 / var(--tw-border-opacity));
}
.tw-border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity));
}
.tw-border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.tw-border-gray-800 {
  --tw-border-opacity: 1;
  border-color: rgb(31 41 55 / var(--tw-border-opacity));
}
.tw-border-slate-800\\/10 {
  border-color: rgb(30 41 59 / 0.1);
}
.tw-border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.tw-border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.tw-border-gray-500 {
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity));
}
.tw-border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity));
}
.tw-border-x-transparent {
  border-left-color: transparent;
  border-right-color: transparent;
}
.tw-border-l-body-light {
  --tw-border-opacity: 1;
  border-left-color: rgb(33 37 41 / var(--tw-border-opacity));
}
.tw-border-t-zinc-300 {
  --tw-border-opacity: 1;
  border-top-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.tw-border-l-layout-line-light {
  --tw-border-opacity: 1;
  border-left-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.tw-border-l-perpul-light {
  --tw-border-opacity: 1;
  border-left-color: rgb(128 0 128 / var(--tw-border-opacity));
}
.tw-border-r-transparent {
  border-right-color: transparent;
}
.tw-border-l-transparent {
  border-left-color: transparent;
}
.\\!tw-bg-transparent {
  background-color: transparent !important;
}
.tw-bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.tw-bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.tw-bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.tw-bg-sky-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
.tw-bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity));
}
.tw-bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.tw-bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.tw-bg-perpul-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(153 2 153 / var(--tw-bg-opacity));
}
.tw-bg-perpul-light {
  --tw-bg-opacity: 1;
  background-color: rgb(128 0 128 / var(--tw-bg-opacity));
}
.tw-bg-purple-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity));
}
.tw-bg-transparent {
  background-color: transparent;
}
.tw-bg-\\[\\#00ff0033\\] {
  background-color: #00ff0033;
}
.tw-bg-\\[\\#ff000066\\] {
  background-color: #ff000066;
}
.tw-bg-slate-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 41 59 / var(--tw-bg-opacity));
}
.tw-bg-purple-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity));
}
.tw-bg-red-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity));
}
.tw-bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(226 232 240 / var(--tw-bg-opacity));
}
.tw-bg-gray-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity));
}
.tw-bg-yellow-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity));
}
.tw-bg-green-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity));
}
.tw-bg-yellow-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity));
}
.tw-bg-yellow-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity));
}
.tw-bg-\\[\\#bae6fd\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(186 230 253 / var(--tw-bg-opacity));
}
.tw-bg-green-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity));
}
.tw-bg-zinc-400\\/20 {
  background-color: rgb(161 161 170 / 0.2);
}
.tw-bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.tw-bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.tw-bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity));
}
.tw-bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.tw-bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity));
}
.tw-bg-zinc-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.tw-bg-zinc-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.tw-bg-zinc-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.tw-bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.tw-bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.tw-bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.\\!tw-bg-opacity-\\[0\\.85\\] {
  --tw-bg-opacity: 0.85 !important;
}
.\\!tw-bg-opacity-60 {
  --tw-bg-opacity: 0.6 !important;
}
.tw-bg-clip-padding {
  background-clip: padding-box;
}
.tw-fill-layout-line-light {
  fill: #e0e0e0;
}
.tw-object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.tw-object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.tw-object-center {
  -o-object-position: center;
     object-position: center;
}
.tw-p-4 {
  padding: 1rem;
}
.tw-p-3 {
  padding: 0.75rem;
}
.tw-p-2 {
  padding: 0.5rem;
}
.tw-p-6 {
  padding: 1.5rem;
}
.tw-p-5 {
  padding: 1.25rem;
}
.tw-p-1 {
  padding: 0.25rem;
}
.tw-p-2\\.5 {
  padding: 0.625rem;
}
.tw-p-\\[3px\\] {
  padding: 3px;
}
.\\!tw-px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.tw-py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.\\!tw-py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}
.tw-px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.tw-py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.tw-px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.tw-py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.tw-py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}
.tw-py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.tw-py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.tw-px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.tw-py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.\\!tw-px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.\\!tw-py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.tw-px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.tw-py-\\[2px\\] {
  padding-top: 2px;
  padding-bottom: 2px;
}
.tw-px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.\\!tw-py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}
.\\!tw-px-4 {
  padding-left: 1rem !important;
  padding-right: 1rem !important;
}
.tw-px-\\[2px\\] {
  padding-left: 2px;
  padding-right: 2px;
}
.tw-px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.tw-py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.\\!tw-px-2 {
  padding-left: 0.5rem !important;
  padding-right: 0.5rem !important;
}
.tw-py-\\[0\\.3125rem\\] {
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
}
.tw-pt-6 {
  padding-top: 1.5rem;
}
.tw-pl-8 {
  padding-left: 2rem;
}
.tw-pr-2 {
  padding-right: 0.5rem;
}
.tw-pl-5 {
  padding-left: 1.25rem;
}
.tw-pt-4 {
  padding-top: 1rem;
}
.tw-pb-1 {
  padding-bottom: 0.25rem;
}
.tw-pr-4 {
  padding-right: 1rem;
}
.tw-pb-4 {
  padding-bottom: 1rem;
}
.tw-pb-3 {
  padding-bottom: 0.75rem;
}
.tw-pt-8 {
  padding-top: 2rem;
}
.tw-pr-6 {
  padding-right: 1.5rem;
}
.tw-pt-2 {
  padding-top: 0.5rem;
}
.tw-pb-2 {
  padding-bottom: 0.5rem;
}
.tw-pl-0 {
  padding-left: 0px;
}
.tw-pl-2 {
  padding-left: 0.5rem;
}
.tw-pr-\\[4rem\\] {
  padding-right: 4rem;
}
.tw-pl-3 {
  padding-left: 0.75rem;
}
.tw-pl-4 {
  padding-left: 1rem;
}
.tw-pl-6 {
  padding-left: 1.5rem;
}
.tw-pl-1 {
  padding-left: 0.25rem;
}
.tw-pt-0 {
  padding-top: 0px;
}
.tw-pb-6 {
  padding-bottom: 1.5rem;
}
.tw-pr-1 {
  padding-right: 0.25rem;
}
.tw-pt-7 {
  padding-top: 1.75rem;
}
.tw-pt-1 {
  padding-top: 0.25rem;
}
.tw-pr-10 {
  padding-right: 2.5rem;
}
.tw-pl-10 {
  padding-left: 2.5rem;
}
.tw-text-left {
  text-align: left;
}
.tw-text-center {
  text-align: center;
}
.tw-text-right {
  text-align: right;
}
.tw-align-middle {
  vertical-align: middle;
}
.tw-align-bottom {
  vertical-align: bottom;
}
.tw-font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.tw-text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.tw-text-xs {
  font-size: 0.8rem;
  line-height: 1rem;
}
.tw-text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.tw-text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.tw-text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.tw-text-\\[0\\.90rem\\] {
  font-size: 0.90rem;
}
.tw-text-\\[1\\.3rem\\] {
  font-size: 1.3rem;
}
.tw-text-\\[1\\.25rem\\] {
  font-size: 1.25rem;
}
.tw-text-\\[1\\.2rem\\] {
  font-size: 1.2rem;
}
.tw-text-\\[1\\.15rem\\] {
  font-size: 1.15rem;
}
.tw-text-\\[1\\.1rem\\] {
  font-size: 1.1rem;
}
.tw-text-\\[1\\.05rem\\] {
  font-size: 1.05rem;
}
.tw-text-\\[0\\.9rem\\] {
  font-size: 0.9rem;
}
.tw-text-\\[0\\.95rem\\] {
  font-size: 0.95rem;
}
.tw-text-\\[90\\%\\] {
  font-size: 90%;
}
.tw-text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.tw-text-\\[5rem\\] {
  font-size: 5rem;
}
.tw-text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.tw-text-\\[1\\.4rem\\] {
  font-size: 1.4rem;
}
.tw-text-5xl {
  font-size: 3rem;
  line-height: 1rem;
}
.tw-font-bold {
  font-weight: 700;
}
.tw-font-semibold {
  font-weight: 600;
}
.tw-font-normal {
  font-weight: 400;
}
.tw-font-medium {
  font-weight: 500;
}
.tw-uppercase {
  text-transform: uppercase;
}
.tw-italic {
  font-style: italic;
}
.tw-leading-none {
  line-height: 1;
}
.tw-leading-tight {
  line-height: 1.25;
}
.tw-leading-7 {
  line-height: 1.75rem;
}
.tw-leading-normal {
  line-height: 1.5;
}
.tw-leading-relaxed {
  line-height: 1.625;
}
.tw-text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.tw-text-body-light {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}
.tw-text-link-blue {
  --tw-text-opacity: 1;
  color: rgb(27 149 224 / var(--tw-text-opacity));
}
.tw-text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.tw-text-purple-600 {
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity));
}
.tw-text-perpul-light {
  --tw-text-opacity: 1;
  color: rgb(128 0 128 / var(--tw-text-opacity));
}
.tw-text-layout-line-light {
  --tw-text-opacity: 1;
  color: rgb(224 224 224 / var(--tw-text-opacity));
}
.tw-text-\\[\\#ff5700\\] {
  --tw-text-opacity: 1;
  color: rgb(255 87 0 / var(--tw-text-opacity));
}
.tw-text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity));
}
.tw-text-\\[\\#c4302b\\] {
  --tw-text-opacity: 1;
  color: rgb(196 48 43 / var(--tw-text-opacity));
}
.tw-text-inherit {
  color: inherit;
}
.tw-text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.tw-text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.tw-underline {
  text-decoration-line: underline;
}
.\\!tw-no-underline {
  text-decoration-line: none !important;
}
.tw-placeholder-gray-600::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(75 85 99 / var(--tw-placeholder-opacity));
}
.tw-placeholder-gray-600::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(75 85 99 / var(--tw-placeholder-opacity));
}
.tw-opacity-90 {
  opacity: 0.9;
}
.tw-opacity-50 {
  opacity: 0.5;
}
.tw-opacity-30 {
  opacity: 0.3;
}
.tw-opacity-70 {
  opacity: 0.7;
}
.tw-opacity-60 {
  opacity: 0.6;
}
.\\!tw-shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.tw-shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.tw-outline {
  outline-style: solid;
}
.tw-outline-black {
  outline-color: #000;
}
.tw-duration-300 {
  transition-duration: 300ms;
}
.tw-line-clamp-3 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.\\!tw-line-clamp-1 {
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 1 !important;
}
.placeholder\\:tw-italic::-moz-placeholder {
  font-style: italic;
}
.placeholder\\:tw-italic::placeholder {
  font-style: italic;
}
.first\\:tw-mt-0:first-child {
  margin-top: 0px;
}
.odd\\:tw-bg-highlight:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(247 247 247 / var(--tw-bg-opacity));
}
.tw-dark .odd\\:tw-bg-highlight:nth-child(odd) {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .hover\\:tw-z-10:hover {
    z-index: 10;
  }

  .hover\\:tw-text-primary:hover {
    --tw-text-opacity: 1;
    color: rgb(33 37 41 / var(--tw-text-opacity));
  }

  .tw-dark .hover\\:tw-text-primary:hover {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-light:hover {
    --tw-text-opacity: 1;
    color: rgb(228 228 231 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-muted:hover {
    --tw-text-opacity: 1;
    color: rgb(105 105 115 / var(--tw-text-opacity));
  }

  .tw-dark .hover\\:tw-text-muted:hover {
    --tw-text-opacity: 1;
    color: rgb(161 161 170 / var(--tw-text-opacity));
  }

  .hover\\:tw-bg-highlight:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(247 247 247 / var(--tw-bg-opacity));
  }

  .tw-dark .hover\\:tw-bg-highlight:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(39 39 42 / var(--tw-bg-opacity));
  }

  .hover\\:tw-story-outline:hover {
    outline-style: solid;
    outline-width: 2px;
    outline-color: #cccccc;
  }

  .tw-dark .hover\\:tw-story-outline:hover {
    outline-color: #333333;
  }

  .hover\\:tw-border-\\[\\#16a34a\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(22 163 74 / var(--tw-border-opacity));
  }

  .hover\\:tw-border-\\[\\#ff0000\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(255 0 0 / var(--tw-border-opacity));
  }

  .hover\\:tw-border-perpul-light:hover {
    --tw-border-opacity: 1;
    border-color: rgb(128 0 128 / var(--tw-border-opacity));
  }

  .hover\\:tw-border-purple-600:hover {
    --tw-border-opacity: 1;
    border-color: rgb(147 51 234 / var(--tw-border-opacity));
  }

  .hover\\:\\!tw-bg-purple-300:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(216 180 254 / var(--tw-bg-opacity)) !important;
  }

  .hover\\:tw-bg-neutral-100:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(245 245 245 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-purple-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(216 180 254 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-gray-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-perpul-light:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(128 0 128 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-gray-300:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(209 213 219 / var(--tw-bg-opacity));
  }

  .hover\\:tw-bg-\\[\\#00ff0033\\]:hover {
    background-color: #00ff0033;
  }

  .hover\\:tw-bg-\\[\\#ff000066\\]:hover {
    background-color: #ff000066;
  }

  .hover\\:\\!tw-bg-yellow-light:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(253 249 186 / var(--tw-bg-opacity)) !important;
  }

  .hover\\:tw-bg-\\[\\#e0e1e6\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(224 225 230 / var(--tw-bg-opacity));
  }

  .hover\\:\\!tw-bg-opacity-100:hover {
    --tw-bg-opacity: 1 !important;
  }

  .hover\\:tw-font-semibold:hover {
    font-weight: 600;
  }

  .hover\\:tw-text-body-light:hover {
    --tw-text-opacity: 1;
    color: rgb(33 37 41 / var(--tw-text-opacity));
  }

  .hover\\:tw-text-inherit:hover {
    color: inherit;
  }

  .hover\\:tw-no-underline:hover {
    text-decoration-line: none;
  }

  .hover\\:tw-opacity-80:hover {
    opacity: 0.8;
  }

  .hover\\:tw-opacity-100:hover {
    opacity: 1;
  }
}
.focus\\:tw-rounded-sm:focus {
  border-radius: 0.125rem;
}
.focus\\:tw-outline:focus {
  outline-style: solid;
}
.focus\\:tw-outline-0:focus {
  outline-width: 0px;
}
.focus\\:tw-outline-zinc-800:focus {
  outline-color: #27272a;
}
.focus-visible\\:tw-outline:focus-visible {
  outline-style: solid;
}
.focus-visible\\:tw-outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:tw-outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:tw-outline-black:focus-visible {
  outline-color: #000;
}
.disabled\\:tw-text-muted:disabled {
  --tw-text-opacity: 1;
  color: rgb(105 105 115 / var(--tw-text-opacity));
}
.tw-dark .disabled\\:tw-text-muted:disabled {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
.disabled\\:tw-bg-primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(254 254 254 / var(--tw-bg-opacity));
}
.tw-dark .disabled\\:tw-bg-primary:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 29 / var(--tw-bg-opacity));
}
.disabled\\:\\!tw-cursor-default:disabled {
  cursor: default !important;
}
.disabled\\:\\!tw-bg-opacity-60:disabled {
  --tw-bg-opacity: 0.6 !important;
}
.disabled\\:tw-text-zinc-100:disabled {
  --tw-text-opacity: 1;
  color: rgb(244 244 245 / var(--tw-text-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .disabled\\:hover\\:\\!tw-bg-opacity-60:hover:disabled {
    --tw-bg-opacity: 0.6 !important;
  }

  .tw-group:hover .group-hover\\:tw-visible {
    visibility: visible;
  }

  .tw-group\\/img-slider:hover .group-hover\\/img-slider\\:tw-visible {
    visibility: visible;
  }

  .tw-group\\/img:hover .group-hover\\/img\\:tw-visible {
    visibility: visible;
  }

  .tw-group:hover .group-hover\\:tw-h-\\[18px\\] {
    height: 18px;
  }

  .tw-group:hover .group-hover\\:tw-opacity-90 {
    opacity: 0.9;
  }
}
.tw-dark .dark\\:tw-text-dark {
  --tw-text-opacity: 1;
  color: rgb(33 37 41 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-bg-striped-dark {
    background-image: linear-gradient(
      45deg,
      #2f2f2f 25%,
      #353535 25%,
      #353535 50%,
      #2f2f2f 50%,
      #2f2f2f 75%,
      #353535 75%,
      #353535 100%
    );
    background-size: 56.57px 56.57px;
  }
.tw-dark .dark\\:\\!tw-border-layout-line-dark {
  --tw-border-opacity: 1 !important;
  border-color: rgb(55 55 55 / var(--tw-border-opacity)) !important;
}
.tw-dark .dark\\:tw-border-layout-line-dark {
  --tw-border-opacity: 1;
  border-color: rgb(55 55 55 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-layout-line-light {
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-perpul-dark {
  --tw-border-opacity: 1;
  border-color: rgb(153 2 153 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-\\[\\#00ff00\\] {
  --tw-border-opacity: 1;
  border-color: rgb(0 255 0 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-\\[\\#767676\\] {
  --tw-border-opacity: 1;
  border-color: rgb(118 118 118 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-slate-100\\/10 {
  border-color: rgb(241 245 249 / 0.1);
}
.tw-dark .dark\\:tw-border-red-700 {
  --tw-border-opacity: 1;
  border-color: rgb(185 28 28 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-green-700 {
  --tw-border-opacity: 1;
  border-color: rgb(21 128 61 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-slate-700 {
  --tw-border-opacity: 1;
  border-color: rgb(51 65 85 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-l-body-dark {
  --tw-border-opacity: 1;
  border-left-color: rgb(226 232 240 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-t-zinc-700 {
  --tw-border-opacity: 1;
  border-top-color: rgb(63 63 70 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-l-layout-line-dark {
  --tw-border-opacity: 1;
  border-left-color: rgb(55 55 55 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-border-l-perpul-dark {
  --tw-border-opacity: 1;
  border-left-color: rgb(153 2 153 / var(--tw-border-opacity));
}
.tw-dark .dark\\:tw-bg-gray-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-\\[\\#211f02\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(33 31 2 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-gray-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-perpul-light {
  --tw-bg-opacity: 1;
  background-color: rgb(128 0 128 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-perpul-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(153 2 153 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-\\[\\#00ff0066\\] {
  background-color: #00ff0066;
}
.tw-dark .dark\\:tw-bg-\\[\\#3b0764\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(59 7 100 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-red-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(153 27 27 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-green-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(20 83 45 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-yellow-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-sky-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(3 105 161 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-red-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-zinc-700\\/20 {
  background-color: rgb(63 63 70 / 0.2);
}
.tw-dark .dark\\:tw-bg-green-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-zinc-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-zinc-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(212 212 216 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-zinc-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-green-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-zinc-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(113 113 122 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.tw-dark .dark\\:tw-fill-layout-line-dark {
  fill: #373737;
}
.tw-dark .dark\\:tw-text-body-dark {
  --tw-text-opacity: 1;
  color: rgb(226 232 240 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-stone-200 {
  --tw-text-opacity: 1;
  color: rgb(231 229 228 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-purple-500 {
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-neutral-700 {
  --tw-text-opacity: 1;
  color: rgb(64 64 64 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-layout-line-dark {
  --tw-text-opacity: 1;
  color: rgb(55 55 55 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-perpul-dark {
  --tw-text-opacity: 1;
  color: rgb(153 2 153 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(51 65 85 / var(--tw-text-opacity));
}
.tw-dark .dark\\:tw-placeholder-gray-400::-moz-placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
.tw-dark .dark\\:tw-placeholder-gray-400::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .tw-dark .dark\\:hover\\:tw-border-\\[\\#00ff00\\]:hover {
    --tw-border-opacity: 1;
    border-color: rgb(0 255 0 / var(--tw-border-opacity));
  }

  .tw-dark .dark\\:hover\\:tw-border-purple-500:hover {
    --tw-border-opacity: 1;
    border-color: rgb(168 85 247 / var(--tw-border-opacity));
  }

  .tw-dark .dark\\:hover\\:\\!tw-bg-purple-700:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(126 34 206 / var(--tw-bg-opacity)) !important;
  }

  .tw-dark .dark\\:hover\\:tw-bg-neutral-800:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(38 38 38 / var(--tw-bg-opacity));
  }

  .tw-dark .dark\\:hover\\:tw-bg-purple-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(126 34 206 / var(--tw-bg-opacity));
  }

  .tw-dark .dark\\:hover\\:tw-bg-gray-700:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(55 65 81 / var(--tw-bg-opacity));
  }

  .tw-dark .hover\\:dark\\:tw-bg-perpul-dark:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(153 2 153 / var(--tw-bg-opacity));
  }

  .tw-dark .dark\\:hover\\:tw-bg-\\[\\#00ff0066\\]:hover {
    background-color: #00ff0066;
  }

  .tw-dark .dark\\:hover\\:tw-bg-\\[\\#3b0764\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(59 7 100 / var(--tw-bg-opacity));
  }

  .tw-dark .dark\\:hover\\:\\!tw-bg-yellow-dark:hover {
    --tw-bg-opacity: 1 !important;
    background-color: rgb(40 39 0 / var(--tw-bg-opacity)) !important;
  }

  .tw-dark .hover\\:dark\\:tw-bg-\\[\\#2e3135\\]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(46 49 53 / var(--tw-bg-opacity));
  }

  .tw-dark .hover\\:dark\\:tw-text-body-dark:hover {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }

  .tw-dark .dark\\:hover\\:tw-text-body-dark:hover {
    --tw-text-opacity: 1;
    color: rgb(226 232 240 / var(--tw-text-opacity));
  }
}
.tw-dark .dark\\:focus\\:tw-outline-zinc-100:focus {
  outline-color: #f4f4f5;
}
.tw-dark .focus-visible\\:dark\\:tw-outline-white:focus-visible {
  outline-color: #fff;
}
.tw-dark .disabled\\:dark\\:\\!tw-bg-opacity-60:disabled {
  --tw-bg-opacity: 0.6 !important;
}
.tw-dark .dark\\:disabled\\:tw-text-zinc-400:disabled {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity));
}
@media (hover: hover) and (pointer: fine) {

  .tw-dark .disabled\\:dark\\:hover\\:\\!tw-bg-opacity-60:hover:disabled {
    --tw-bg-opacity: 0.6 !important;
  }
}
@media not all and (min-width: 1024px) {

  .max-lg\\:tw-justify-center {
    justify-content: center;
  }

  .max-lg\\:tw-px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .max-lg\\:tw-pl-2 {
    padding-left: 0.5rem;
  }
}
@media not all and (min-width: 640px) {

  .max-sm\\:tw-flex-col {
    flex-direction: column;
  }

  .max-sm\\:tw-justify-between {
    justify-content: space-between;
  }

  .max-sm\\:tw-pr-2 {
    padding-right: 0.5rem;
  }
}
@media (min-width: 640px) {

  .sm\\:tw-col-span-9 {
    grid-column: span 9 / span 9;
  }

  .sm\\:tw-col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:tw-col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:tw-col-span-11 {
    grid-column: span 11 / span 11;
  }

  .sm\\:tw-mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:tw-block {
    display: block;
  }

  .sm\\:tw-inline {
    display: inline;
  }

  .sm\\:tw-flex {
    display: flex;
  }

  .sm\\:tw-inline-flex {
    display: inline-flex;
  }

  .sm\\:tw-hidden {
    display: none;
  }

  .sm\\:\\!tw-hidden {
    display: none !important;
  }

  .sm\\:tw-h-\\[180px\\] {
    height: 180px;
  }

  .sm\\:tw-h-screen {
    height: 100vh;
  }

  .sm\\:tw-w-\\[180px\\] {
    width: 180px;
  }

  .sm\\:tw-w-full {
    width: 100%;
  }

  .sm\\:tw-min-w-fit {
    min-width: -moz-fit-content;
    min-width: fit-content;
  }

  .sm\\:tw-min-w-\\[10rem\\] {
    min-width: 10rem;
  }

  .sm\\:tw-max-w-\\[15rem\\] {
    max-width: 15rem;
  }

  .sm\\:tw-max-w-\\[21rem\\] {
    max-width: 21rem;
  }

  .sm\\:tw-max-w-\\[560px\\] {
    max-width: 560px;
  }

  .sm\\:tw-basis-\\[14rem\\] {
    flex-basis: 14rem;
  }

  .sm\\:tw-grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:tw-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:tw-items-center {
    align-items: center;
  }

  .sm\\:tw-gap-x-4 {
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .sm\\:tw-overflow-y-scroll {
    overflow-y: scroll;
  }

  .sm\\:tw-px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:\\!tw-px-6 {
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
  }

  .sm\\:tw-px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:tw-pr-\\[5px\\] {
    padding-right: 5px;
  }

  .sm\\:tw-text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  @media not all and (min-width: 1024px) {

    .sm\\:max-lg\\:tw-flex {
      display: flex;
    }

    .sm\\:max-lg\\:tw-hidden {
      display: none;
    }

    .sm\\:max-lg\\:tw-justify-center {
      justify-content: center;
    }
  }
}
@media (min-width: 768px) {

  .md\\:tw-left-1\\/2 {
    left: 50%;
  }

  .md\\:tw-col-span-1 {
    grid-column: span 1 / span 1;
  }

  .md\\:tw-col-span-11 {
    grid-column: span 11 / span 11;
  }

  .md\\:tw-col-span-9 {
    grid-column: span 9 / span 9;
  }

  .md\\:tw-col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:tw-mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .md\\:tw-ml-\\[-33\\.33\\%\\] {
    margin-left: -33.33%;
  }

  .md\\:tw-block {
    display: block;
  }

  .md\\:tw-inline-block {
    display: inline-block;
  }

  .md\\:tw-hidden {
    display: none;
  }

  .md\\:tw-w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:tw-w-80 {
    width: 20rem;
  }

  .md\\:\\!tw-w-60 {
    width: 15rem !important;
  }

  .md\\:tw-max-w-\\[660px\\] {
    max-width: 660px;
  }

  .md\\:tw-grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:tw-px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:tw-pl-3 {
    padding-left: 0.75rem;
  }
}
@media (min-width: 1024px) {

  .lg\\:tw-col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:tw-col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:tw-col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:tw-col-span-10 {
    grid-column: span 10 / span 10;
  }

  .lg\\:tw-mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .lg\\:tw-ml-4 {
    margin-left: 1rem;
  }

  .lg\\:tw-block {
    display: block;
  }

  .lg\\:tw-inline {
    display: inline;
  }

  .lg\\:tw-flex {
    display: flex;
  }

  .lg\\:tw-hidden {
    display: none;
  }

  .lg\\:tw-max-h-\\[12rem\\] {
    max-height: 12rem;
  }

  .lg\\:tw-max-w-lg {
    max-width: 32rem;
  }

  .lg\\:tw-max-w-\\[860px\\] {
    max-width: 860px;
  }

  .lg\\:tw-items-center {
    align-items: center;
  }

  .lg\\:tw-px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:tw-pl-4 {
    padding-left: 1rem;
  }

  .lg\\:tw-pb-1 {
    padding-bottom: 0.25rem;
  }

  .lg\\:tw-pl-6 {
    padding-left: 1.5rem;
  }

  .lg\\:\\!tw-line-clamp-1 {
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
  }
}
@media (min-width: 1280px) {

  .xl\\:tw-col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:tw-col-span-10 {
    grid-column: span 10 / span 10;
  }
}
.\\[\\&\\>ul\\]\\:tw-pl-5>ul {
  padding-left: 1.25rem;
}
.\\[\\&\\>ol\\]\\:tw-pl-5>ol {
  padding-left: 1.25rem;
}
.\\[\\&_p\\]\\:tw-mb-0 p {
  margin-bottom: 0px;
}
.\\[\\&_\\.twitter-tweet\\]\\:tw-mx-auto .twitter-tweet {
  margin-left: auto;
  margin-right: auto;
}
.\\[\\&_iframe\\]\\:tw-absolute iframe {
  position: absolute;
}
.\\[\\&_iframe\\]\\:tw-top-0 iframe {
  top: 0px;
}
.\\[\\&_iframe\\]\\:tw-left-0 iframe {
  left: 0px;
}
.\\[\\&_iframe\\]\\:tw-h-full iframe {
  height: 100%;
}
.\\[\\&_iframe\\]\\:tw-w-full iframe {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,uOAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAA;AAAc;;AAEd;;;;;;;CAOC;;AAED;;;CAGC;AACD;EACE,eAAe;AACjB;;AAGE;EAAA,oBAAwB;EAAxB,+CAAA;AAAwB;;AAIxB;EAAA,+BAAA;AAAmB;;AAInB;EAAA,mBAAA;AAAc;;AAGhB;;;;CAIC;AACD;EACE,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,gCAAkD;EAClD,4BAA4B,EAAE,+BAA+B;EAC7D,gCAAgC,EAAE,6BAA6B;EAC/D,8BAA8B;EAC9B,kCAAsD;EACtD,sCAA0D;EAC1D,8BAAgD;AAClD;;AAEA;EACE,kCAAuD;EACvD,sCAA2D;EAC3D,gCAAkD;EAClD,4BAA4B,EAAE,+BAA+B;EAC7D,gCAAgC,EAAE,6BAA6B;AACjE;AACA,kEAAkE;;AAGhE;EAAA,aAAqC;EAArC,sBAAqC;EAArC,aAAqC;EACrC,oBAAiC;EAAjC,6CAAA;AADqC;;AACrC;EAAA,oBAAiC;EAAjC,gDAAA;AAAiC;;AAAjC;EAAA,mBAAiC;EAAjC,oBAAiC;EACjC,iBAAA;AADiC;;AAI/B;EAAA,aAAqC;EAArC,sBAAqC;EAArC,aAAqC;EACrC,kBAAsB;EAAtB,yDAAA;AADqC;;AACrC;EAAA,kBAAsB;EAAtB,sDAAA;AAAsB;;AACtB;EAAA,gBAAkB;EAClB,oBAA8B;EAA9B,uBAA8B;EAA9B,kBAA8B;EAA9B,qBAA8B;EAC9B,qBAAoF;EAApF,sBAAoF;EAApF,sBAAoF;EAApF,2DAAA;AAFkB;;AAElB;EAAA,sBAAoF;EAApF,8DAAA;AAAoF;;AASpF;;;;;;EAAA,gBAAA;AAA4B;;AAA5B;;;;;;EAAA,eAAA;AAA4B;;AAI5B;EAAA,iBAAoC;EAApC,gBAAA;AAAoC;;AAIpC;EAAA,kBAAqC;EAArC,gBAAA;AAAqC;;AAIrC;EAAA,iBAAoC;EAApC,gBAAA;AAAoC;;AAIpC;EAAA,kBAAqC;EAArC,gBAAA;AAAqC;;AAIrC;EAAA,kBAAyC;EAAzC,gBAAA;AAAyC;;AAIzC;EAAA,kBAAyC;EAAzC,gBAAA;AAAyC;;AAIzC;EAAA,4BAA8C;EAA9C,wBAA8C;EAA9C,qBAA8C;EAC9C,aAAqC;EAArC,sBAAqC;EAArC,gBAAA;AAD8C;;AAK9C;EAAA,4BAA2C;EAA3C,qBAA2C;EAA3C,qBAA2C;EAC3C,aAAqC;EAArC,sBAAqC;EAArC,gBAAA;AAD2C;;AAK3C;EAAA,eAAc;EAAd,kBAAA;AAAc;;AACd;EAAA,qBAAA;AAAoC;;AAApC;EAAA,qBAAA;AAAoC;;AAIpC;EAAA,kBAAA;AAAc;;AAId;EAAA,oBAAyG;EAAzG,gDAAyG;EAAzG,kBAAyG;EAAzG,uBAAyG;EAAzG,kBAAyG;EAAzG,sDAAyG;EAAzG,gBAAyG;EAAzG,mBAAyG;EAAzG,oBAAyG;EAAzG,iBAAA;AAAyG;;AAI7G;EAAA,WAAA;AAAoB;;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,gBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;AAApB;;EAAA;IAAA,iBAAA;EAAoB;AAAA;;AAIlB;;;;GAIC;;AAED;;;;;;;;GAQC;;AAEC;EADF;MAEI,iCAAiC;MACjC;EAEJ;IADE;;AAGF;IACE,UAAU;IACV,WAAW;EACb;;AAEA;IACE,uBAAuB;EACzB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,gBAAgB;EAClB;;AAEA;;IAEE;;AAGA;EAAA,oBAA+C;EAA/C,6CAAA;AAA+C;;AAA/C;EAAA,oBAA+C;EAA/C,gDAAA;AAA+C;;AAI/C;EAAA,oBAA+C;EAA/C,gDAAA;AAA+C;;AAA/C;EAAA,oBAA+C;EAA/C,6CAAA;AAA+C;;AAI/C;EAAA,oBAAuB;EAAvB,gDAAA;AAAuB;;AAIvB;EAAA,oBAAwB;EAAxB,6CAAA;AAAwB;;AAIxB;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;;AAA9C;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;;AAI9C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAI3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAI3C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAI3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAG7C;IACE;;;;;;;;;KASC;IACD,gCAAgC;EAClC;;AAiBE;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;;AAQ3C;EAAA,oBAA2C;EAA3C,+CAAA;AAA2C;;AAA3C;;EAAA;IAAA,+BAAA;EAA2C;AAAA;;AAG7C;IACE,oCAAoC;EACtC;;AAEA;;IAEE;;AAEF,8CAA8C;;AAE5C;EAAA,iBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,8BAAsG;EACtG,kBAAc;EAAd,mBAAA;AADsG;;AAKtG;EAAA,iBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,8BAAsG;EACtG,kBAAc;EAAd,mBAAA;AADsG;;AAKtG;EAAA,iCAA8D;EAA9D,uEAAA;AAA8D;;AAA9D;EAAA,iCAA8D;EAA9D,uEAAA;AAA8D;;AAI9D;EAAA,iBAAsG;EAAtG,qBAAsG;EAAtG,wBAAsG;EAAtG,sBAAsG;EAAtG,uBAAsG;EAAtG,mBAAsG;EAAtG,8BAAA;AAAsG;;AAItG;EAAA,iCAA8D;EAA9D,uEAAA;AAA8D;;AAA9D;EAAA,iCAA8D;EAA9D,uEAAA;AAA8D;;AAGhE;;GAEC;;AAED;IACE;gEAC4D;IAC5D;;uCAEmC;IACnC,4BAA4B;IAC5B;;aAES;EACX;AAvLF;EAAA,kBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,QAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,6BAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,0CAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,UAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,sCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,+LAAA;AAAmB;AAAnB;EAAA,+LAAA;AAAmB;AAAnB;;EAAA;IAAA,yBAAA;EAAmB;AAAA;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,yBAAmB;KAAnB,sBAAmB;UAAnB,iBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,wBAAmB;KAAnB,qBAAmB;UAAnB,gBAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,iDAAA;AAAmB;AAAnB;EAAA,gDAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,WAAA;AAAmB;AAAnB;EAAA,SAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB,kBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB,gBAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;OAAnB,gBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB,mCAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,oCAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,wBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sCAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,oEAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,qDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,iCAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,+BAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,2DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,6DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8DAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,4DAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,8BAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,6BAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,2BAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,wDAAA;AAAmB;AAAnB;EAAA,wCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,uDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,sDAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,yDAAA;AAAmB;AAAnB;EAAA,gCAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,4BAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB,mBAAA;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB,iBAAA;AAAmB;AAAnB;EAAA,0BAAmB;KAAnB,uBAAA;AAAmB;AAAnB;EAAA,aAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB,iCAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,uBAAA;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,6BAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,sBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,kCAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB,8BAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,kBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB,wBAAA;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,gCAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,yBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,uBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,qBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,sBAAA;AAAmB;AAAnB;EAAA,+GAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,eAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,iBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,yBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,iBAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,gBAAA;AAAmB;AAAnB;EAAA,kBAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,+CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,gDAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,cAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,8CAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,6CAAA;AAAmB;AAAnB;EAAA,+BAAA;AAAmB;AAAnB;EAAA,qCAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,oDAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,YAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB,yCAAmB;EAAnB,kHAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB,uGAAA;AAAmB;AAAnB;EAAA,oBAAA;AAAmB;AAAnB;EAAA,mBAAA;AAAmB;AAAnB;EAAA,0BAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB,qBAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB,+BAAmB;EAAnB,uCAAmB;EAAnB,gCAAA;AAAmB;AAnInB;EAAA,kBAAA;AAopFA;AAppFA;EAAA,kBAAA;AAupFA;AAvpFA;EAAA,eAAA;AA0pFA;AA57EI;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;AA9N/C;;EAAA;IAAA,WAAA;EAuqFE;;EAvqFF;IAAA,oBAAA;IAAA,6CAAA;EA4qFE;;EA5qFF;IAAA,oBAAA;IAAA,gDAAA;EAirFE;;EAjrFF;IAAA,oBAAA;IAAA,gDAAA;EAsrFE;;EAtrFF;IAAA,oBAAA;IAAA,gDAAA;EA2rFE;;EA3rFF;IAAA,oBAAA;IAAA,gDAAA;EAgsFE;;EAhsFF;IAAA,kBAAA;IAAA,yDAAA;EAqsFE;;EArsFF;IAAA,kBAAA;IAAA,sDAAA;EA0sFE;;EA1sFF;IAAA,oBAAA;IAAA,kBAAA;IAAA,sBAAA;EAgtFE;;EAhtFF;IAAA,sBAAA;EAotFE;;EAptFF;IAAA,sBAAA;IAAA,uDAAA;EAytFE;;EAztFF;IAAA,sBAAA;IAAA,qDAAA;EA8tFE;;EA9tFF;IAAA,sBAAA;IAAA,uDAAA;EAmuFE;;EAnuFF;IAAA,sBAAA;IAAA,wDAAA;EAwuFE;;EAxuFF;IAAA,6BAAA;IAAA,oEAAA;EA6uFE;;EA7uFF;IAAA,kBAAA;IAAA,yDAAA;EAkvFE;;EAlvFF;IAAA,kBAAA;IAAA,yDAAA;EAuvFE;;EAvvFF;IAAA,kBAAA;IAAA,yDAAA;EA4vFE;;EA5vFF;IAAA,kBAAA;IAAA,uDAAA;EAiwFE;;EAjwFF;IAAA,kBAAA;IAAA,yDAAA;EAswFE;;EAtwFF;IAAA,2BAAA;EA0wFE;;EA1wFF;IAAA,2BAAA;EA8wFE;;EA9wFF;IAAA,6BAAA;IAAA,oEAAA;EAmxFE;;EAnxFF;IAAA,kBAAA;IAAA,yDAAA;EAwxFE;;EAxxFF;IAAA,6BAAA;EA4xFE;;EA5xFF;IAAA,gBAAA;EAgyFE;;EAhyFF;IAAA,oBAAA;IAAA,6CAAA;EAqyFE;;EAryFF;IAAA,cAAA;EAyyFE;;EAzyFF;IAAA,0BAAA;EA6yFE;;EA7yFF;IAAA,YAAA;EAizFE;;EAjzFF;IAAA,UAAA;EAqzFE;AACF;AAtzFA;EAAA,uBAAA;AAyzFA;AAzzFA;EAAA,oBAAA;AA4zFA;AA5zFA;EAAA,kBAAA;AA+zFA;AA/zFA;EAAA,sBAAA;AAk0FA;AAl0FA;EAAA,oBAAA;AAq0FA;AAr0FA;EAAA,kBAAA;AAw0FA;AAx0FA;EAAA,mBAAA;AA20FA;AA30FA;EAAA,mBAAA;AA80FA;AA5nFI;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;AAA9C;EAAA,oBAA8C;EAA9C,gDAAA;AAA8C;AAI9C;EAAA,kBAA2C;EAA3C,yDAAA;AAA2C;AAA3C;EAAA,kBAA2C;EAA3C,sDAAA;AAA2C;AAtN/C;EAAA,0BAAA;AAi2FA;AAj2FA;EAAA,+BAAA;AAo2FA;AAp2FA;EAAA,oBAAA;EAAA,gDAAA;AAw2FA;AAx2FA;;EAAA;IAAA,+BAAA;EA62FE;;EA72FF;IAAA,mBAAA;EAi3FE;;EAj3FF;IAAA,mBAAA;EAq3FE;;EAr3FF;IAAA,mBAAA;EAy3FE;;EAz3FF;IAAA,YAAA;EA63FE;;EA73FF;IAAA,YAAA;EAi4FE;AACF;AAprFI;EAAA,oBAAwB;EAAxB,6CAAA;AAAwB;AAqC1B;IACE;;;;;;;;;KASC;IACD,gCAAgC;EAClC;AA/PF;EAAA,iCAAA;EAAA,iEAAA;AAu5FA;AAv5FA;EAAA,sBAAA;EAAA,sDAAA;AA25FA;AA35FA;EAAA,sBAAA;EAAA,yDAAA;AA+5FA;AA/5FA;EAAA,sBAAA;EAAA,uDAAA;AAm6FA;AAn6FA;EAAA,sBAAA;EAAA,qDAAA;AAu6FA;AAv6FA;EAAA,sBAAA;EAAA,yDAAA;AA26FA;AA36FA;EAAA,sBAAA;EAAA,yDAAA;AA+6FA;AA/6FA;EAAA,oCAAA;AAk7FA;AAl7FA;EAAA,sBAAA;EAAA,uDAAA;AAs7FA;AAt7FA;EAAA,sBAAA;EAAA,uDAAA;AA07FA;AA17FA;EAAA,sBAAA;EAAA,sDAAA;AA87FA;AA97FA;EAAA,sBAAA;EAAA,yDAAA;AAk8FA;AAl8FA;EAAA,sBAAA;EAAA,yDAAA;AAs8FA;AAt8FA;EAAA,sBAAA;EAAA,8DAAA;AA08FA;AA18FA;EAAA,sBAAA;EAAA,0DAAA;AA88FA;AA98FA;EAAA,sBAAA;EAAA,2DAAA;AAk9FA;AAl9FA;EAAA,sBAAA;EAAA,4DAAA;AAs9FA;AAt9FA;EAAA,kBAAA;EAAA,sDAAA;AA09FA;AA19FA;EAAA,kBAAA;EAAA,qDAAA;AA89FA;AA99FA;EAAA,kBAAA;EAAA,sDAAA;AAk+FA;AAl+FA;EAAA,kBAAA;EAAA,uDAAA;AAs+FA;AAt+FA;EAAA,kBAAA;EAAA,uDAAA;AA0+FA;AA1+FA;EAAA,kBAAA;EAAA,wDAAA;AA8+FA;AA9+FA;EAAA,2BAAA;AAi/FA;AAj/FA;EAAA,kBAAA;EAAA,sDAAA;AAq/FA;AAr/FA;EAAA,kBAAA;EAAA,sDAAA;AAy/FA;AAz/FA;EAAA,kBAAA;EAAA,uDAAA;AA6/FA;AA7/FA;EAAA,kBAAA;EAAA,yDAAA;AAigGA;AAjgGA;EAAA,kBAAA;EAAA,sDAAA;AAqgGA;AArgGA;EAAA,kBAAA;EAAA,sDAAA;AAygGA;AAzgGA;EAAA,kBAAA;EAAA,uDAAA;AA6gGA;AA7gGA;EAAA,kBAAA;EAAA,uDAAA;AAihGA;AAjhGA;EAAA,kBAAA;EAAA,uDAAA;AAqhGA;AArhGA;EAAA,kBAAA;EAAA,uDAAA;AAyhGA;AAzhGA;EAAA,qCAAA;AA4hGA;AA5hGA;EAAA,kBAAA;EAAA,uDAAA;AAgiGA;AAhiGA;EAAA,kBAAA;EAAA,sDAAA;AAoiGA;AApiGA;EAAA,kBAAA;EAAA,yDAAA;AAwiGA;AAxiGA;EAAA,kBAAA;EAAA,sDAAA;AA4iGA;AA5iGA;EAAA,kBAAA;EAAA,yDAAA;AAgjGA;AAhjGA;EAAA,kBAAA;EAAA,sDAAA;AAojGA;AApjGA;EAAA,kBAAA;EAAA,uDAAA;AAwjGA;AAxjGA;EAAA,kBAAA;EAAA,yDAAA;AA4jGA;AA5jGA;EAAA,kBAAA;EAAA,yDAAA;AAgkGA;AAhkGA;EAAA,aAAA;AAmkGA;AAnkGA;EAAA,oBAAA;EAAA,gDAAA;AAukGA;AAvkGA;EAAA,oBAAA;EAAA,gDAAA;AA2kGA;AA3kGA;EAAA,oBAAA;EAAA,+CAAA;AA+kGA;AA/kGA;EAAA,oBAAA;EAAA,6CAAA;AAmlGA;AAnlGA;EAAA,oBAAA;EAAA,6CAAA;AAulGA;AAvlGA;EAAA,oBAAA;EAAA,8CAAA;AA2lGA;AA3lGA;EAAA,oBAAA;EAAA,8CAAA;AA+lGA;AA/lGA;EAAA,oBAAA;EAAA,8CAAA;AAmmGA;AAnmGA;EAAA,oBAAA;EAAA,6CAAA;AAumGA;AAvmGA;EAAA,2BAAA;EAAA,uDAAA;AA2mGA;AA3mGA;EAAA,2BAAA;EAAA,uDAAA;AA+mGA;AA/mGA;;EAAA;IAAA,sBAAA;IAAA,qDAAA;EAqnGE;;EArnGF;IAAA,sBAAA;IAAA,wDAAA;EA0nGE;;EA1nGF;IAAA,6BAAA;IAAA,mEAAA;EA+nGE;;EA/nGF;IAAA,kBAAA;IAAA,sDAAA;EAooGE;;EApoGF;IAAA,kBAAA;IAAA,wDAAA;EAyoGE;;EAzoGF;IAAA,kBAAA;IAAA,sDAAA;EA8oGE;;EA9oGF;IAAA,kBAAA;IAAA,uDAAA;EAmpGE;;EAnpGF;IAAA,2BAAA;EAupGE;;EAvpGF;IAAA,kBAAA;IAAA,sDAAA;EA4pGE;;EA5pGF;IAAA,6BAAA;IAAA,gEAAA;EAiqGE;;EAjqGF;IAAA,kBAAA;IAAA,sDAAA;EAsqGE;;EAtqGF;IAAA,oBAAA;IAAA,gDAAA;EA2qGE;;EA3qGF;IAAA,oBAAA;IAAA,gDAAA;EAgrGE;AACF;AAjrGA;EAAA,sBAAA;AAorGA;AAprGA;EAAA,mBAAA;AAurGA;AAvrGA;EAAA,+BAAA;AA0rGA;AA1rGA;EAAA,oBAAA;EAAA,gDAAA;AA8rGA;AA9rGA;;EAAA;IAAA,+BAAA;EAmsGE;AACF;AApsGA;;EAAA;IAAA,uBAAA;EAysGE;;EAzsGF;IAAA,oBAAA;IAAA,qBAAA;EA8sGE;;EA9sGF;IAAA,oBAAA;EAktGE;AACF;AAntGA;;EAAA;IAAA,sBAAA;EAwtGE;;EAxtGF;IAAA,8BAAA;EA4tGE;;EA5tGF;IAAA,qBAAA;EAguGE;AACF;AAjuGA;;EAAA;IAAA,4BAAA;EAsuGE;;EAtuGF;IAAA,4BAAA;EA0uGE;;EA1uGF;IAAA,4BAAA;EA8uGE;;EA9uGF;IAAA,8BAAA;EAkvGE;;EAlvGF;IAAA,iBAAA;IAAA,kBAAA;EAuvGE;;EAvvGF;IAAA,cAAA;EA2vGE;;EA3vGF;IAAA,eAAA;EA+vGE;;EA/vGF;IAAA,aAAA;EAmwGE;;EAnwGF;IAAA,oBAAA;EAuwGE;;EAvwGF;IAAA,aAAA;EA2wGE;;EA3wGF;IAAA,wBAAA;EA+wGE;;EA/wGF;IAAA,aAAA;EAmxGE;;EAnxGF;IAAA,aAAA;EAuxGE;;EAvxGF;IAAA,YAAA;EA2xGE;;EA3xGF;IAAA,WAAA;EA+xGE;;EA/xGF;IAAA,2BAAA;IAAA,sBAAA;EAoyGE;;EApyGF;IAAA,gBAAA;EAwyGE;;EAxyGF;IAAA,gBAAA;EA4yGE;;EA5yGF;IAAA,gBAAA;EAgzGE;;EAhzGF;IAAA,gBAAA;EAozGE;;EApzGF;IAAA,iBAAA;EAwzGE;;EAxzGF;IAAA,gDAAA;EA4zGE;;EA5zGF;IAAA,gDAAA;EAg0GE;;EAh0GF;IAAA,mBAAA;EAo0GE;;EAp0GF;IAAA,qBAAA;SAAA,gBAAA;EAy0GE;;EAz0GF;IAAA,kBAAA;EA60GE;;EA70GF;IAAA,oBAAA;IAAA,qBAAA;EAk1GE;;EAl1GF;IAAA,+BAAA;IAAA,gCAAA;EAu1GE;;EAv1GF;IAAA,kBAAA;IAAA,mBAAA;EA41GE;;EA51GF;IAAA,kBAAA;EAg2GE;;EAh2GF;IAAA,mBAAA;IAAA,oBAAA;EAq2GE;;EAr2GF;;IAAA;MAAA,aAAA;IA22GI;;IA32GJ;MAAA,aAAA;IA+2GI;;IA/2GJ;MAAA,uBAAA;IAm3GI;EACF;AACF;AAr3GA;;EAAA;IAAA,SAAA;EA03GE;;EA13GF;IAAA,4BAAA;EA83GE;;EA93GF;IAAA,8BAAA;EAk4GE;;EAl4GF;IAAA,4BAAA;EAs4GE;;EAt4GF;IAAA,4BAAA;EA04GE;;EA14GF;IAAA,mBAAA;IAAA,oBAAA;EA+4GE;;EA/4GF;IAAA,oBAAA;EAm5GE;;EAn5GF;IAAA,cAAA;EAu5GE;;EAv5GF;IAAA,qBAAA;EA25GE;;EA35GF;IAAA,aAAA;EA+5GE;;EA/5GF;IAAA,iBAAA;EAm6GE;;EAn6GF;IAAA,YAAA;EAu6GE;;EAv6GF;IAAA,uBAAA;EA26GE;;EA36GF;IAAA,gBAAA;EA+6GE;;EA/6GF;IAAA,gDAAA;EAm7GE;;EAn7GF;IAAA,oBAAA;IAAA,qBAAA;EAw7GE;;EAx7GF;IAAA,qBAAA;EA47GE;AACF;AA77GA;;EAAA;IAAA,4BAAA;EAk8GE;;EAl8GF;IAAA,4BAAA;EAs8GE;;EAt8GF;IAAA,4BAAA;EA08GE;;EA18GF;IAAA,8BAAA;EA88GE;;EA98GF;IAAA,iBAAA;IAAA,kBAAA;EAm9GE;;EAn9GF;IAAA,iBAAA;EAu9GE;;EAv9GF;IAAA,cAAA;EA29GE;;EA39GF;IAAA,eAAA;EA+9GE;;EA/9GF;IAAA,aAAA;EAm+GE;;EAn+GF;IAAA,aAAA;EAu+GE;;EAv+GF;IAAA,iBAAA;EA2+GE;;EA3+GF;IAAA,gBAAA;EA++GE;;EA/+GF;IAAA,gBAAA;EAm/GE;;EAn/GF;IAAA,mBAAA;EAu/GE;;EAv/GF;IAAA,kBAAA;IAAA,mBAAA;EA4/GE;;EA5/GF;IAAA,kBAAA;EAggHE;;EAhgHF;IAAA,uBAAA;EAogHE;;EApgHF;IAAA,oBAAA;EAwgHE;;EAxgHF;IAAA,2BAAA;IAAA,+BAAA;IAAA,uCAAA;IAAA,gCAAA;EA+gHE;AACF;AAhhHA;;EAAA;IAAA,4BAAA;EAqhHE;;EArhHF;IAAA,8BAAA;EAyhHE;AACF;AA1hHA;EAAA,qBAAA;AA6hHA;AA7hHA;EAAA,qBAAA;AAgiHA;AAhiHA;EAAA,kBAAA;AAmiHA;AAniHA;EAAA,iBAAA;EAAA,kBAAA;AAuiHA;AAviHA;EAAA,kBAAA;AA0iHA;AA1iHA;EAAA,QAAA;AA6iHA;AA7iHA;EAAA,SAAA;AAgjHA;AAhjHA;EAAA,YAAA;AAmjHA;AAnjHA;EAAA,WAAA;AAsjHA","sourcesContent":["@tailwind base;\n\n/*\nNOTE: Inter font:\n- Defined in HTML template for easy toggling of static() path in trinity & prod (CDN).\n- To save bandwidth, do not include variable italic form.\n- Experimental version with oblique style for italic is too experimental.\n- To save bandwidth, only latin characters are loaded (70KB vs 318KB).\n- Font preload added to HTML template.\n*/\n\n/*\nThese overrides match bootstrap's reset since a lot of styling was developed\nassumings its reset values.\n*/\nsvg {\n  display: inline;\n}\n\na {\n  @apply tw-text-link-blue;\n}\n\na:hover {\n  @apply tw-underline;\n}\n\np {\n  @apply tw-mb-4;\n}\n\n/*\nQUICK FIX: Without this, <input> forces fieldset to expand beyond its parent\ncontainer. This, however, doesn't appear to be a common problem (when searching\nfor reasons for this) so it's unclear why 'auto' isn't the default.\n*/\nfieldset {\n  min-inline-size: auto;\n}\n\n/* stylelint-disable custom-property-pattern, function-no-unknown */\n.mdx-editor-container-dark {\n  --accentText: theme('colors.link-blue') !important;\n  --baseBg: #27272a !important; /* Equivalent to bg-highlight */\n  --basePageBg: #1a1a1d !important; /* Equivalent to bg-primary */\n  --baseBgHover: #333 !important;\n  --accentBorder: theme('colors.perpul-dark') !important;\n  --accentSolidHover: theme('colors.perpul-dark') !important;\n  --baseText: theme('colors.slate.200') !important;\n}\n\n.mdx-editor-container-light {\n  --accentBorder: theme('colors.perpul-light') !important;\n  --accentSolidHover: theme('colors.perpul-light') !important;\n  --accentText: theme('colors.link-blue') !important;\n  --baseBg: #f7f7f7 !important; /* Equivalent to bg-highlight */\n  --basePageBg: #fefefe !important; /* Equivalent to bg-primary */\n}\n/* stylelint-enable custom-property-pattern, function-no-unknown */\n\n.mdx-editor-content {\n  @apply tw-flex tw-flex-col tw-gap-y-4;\n  @apply tw-text-primary tw-text-sm;\n  @apply tw-p-2.5;\n\n  blockquote {\n    @apply tw-flex tw-flex-col tw-gap-y-4;\n    @apply tw-bg-highlight;\n    @apply tw-ml-[2px];\n    @apply tw-pl-8 tw-pr-2 tw-py-3;\n    @apply tw-border-l-4 tw-rounded-lg tw-border-l-body-light dark:tw-border-l-body-dark;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    @apply tw-mt-4 first:tw-mt-0;\n  }\n\n  h1 {\n    @apply tw-text-[1.3rem] tw-font-bold;\n  }\n\n  h2 {\n    @apply tw-text-[1.25rem] tw-font-bold;\n  }\n\n  h3 {\n    @apply tw-text-[1.2rem] tw-font-bold;\n  }\n\n  h4 {\n    @apply tw-text-[1.15rem] tw-font-bold;\n  }\n\n  h5 {\n    @apply tw-text-[1.10rem] tw-font-semibold;\n  }\n\n  h6 {\n    @apply tw-text-[1.05rem] tw-font-semibold;\n  }\n\n  ol {\n    @apply tw-pl-5 tw-list-decimal tw-list-outside;\n    @apply tw-flex tw-flex-col tw-gap-y-1;\n  }\n\n  ul {\n    @apply tw-pl-5 tw-list-disc tw-list-outside;\n    @apply tw-flex tw-flex-col tw-gap-y-1;\n  }\n\n  li {\n    @apply tw-my-0;\n    @apply [&>ul]:tw-pl-5 [&>ol]:tw-pl-5;\n  }\n\n  p {\n    @apply tw-mb-0;\n  }\n\n  .cm-editor {\n    @apply tw-bg-gray-800 tw-text-light tw-p-3 tw-rounded-md tw-text-sm tw-leading-tight tw-overflow-x-scroll;\n  }\n}\n\n@tailwind components;\n@tailwind utilities;\n\n@layer components {\n  /*\n   * Scrollbar\n   * The primary goal is to customize the horizontal scrollbar for horizontal\n   * feeds as the default is too ugly to bear.\n  */\n\n  /*\n    Firefox only\n\n    Styles are disabled for chrome/webkit because if they're specified they\n    take priority. See:\n\n    https://syntackle.com/blog/changes-to-scrollbar-styling-in-chrome-121/\n\n  */\n  .ff-scrollbar {\n    @supports not selector(::-webkit-scrollbar) {\n      scrollbar-color: #888 transparent;\n      scrollbar-width: thin;\n    }\n  }\n\n  ::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n  }\n\n  ::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: #888;\n  }\n\n  .modal-scrollbar::-webkit-scrollbar-thumb {\n    background: #444;\n  }\n\n  .modal-scrollbar::-webkit-scrollbar-thumb:hover {\n    background: #333;\n  }\n\n  .tw-dark ::-webkit-scrollbar-thumb {\n    background: #777;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    background: #444;\n  }\n\n  .tw-dark ::-webkit-scrollbar-thumb:hover {\n    background: #aaa;\n  }\n\n  /*\n   * Other styles\n   */\n\n  .tw-text-primary {\n    @apply tw-text-[#212529] dark:tw-text-slate-200;\n  }\n\n  .tw-text-primary-inverted {\n    @apply dark:tw-text-[#212529] tw-text-slate-200;\n  }\n\n  .tw-text-light {\n    @apply tw-text-zinc-200;\n  }\n\n  .tw-text-dark {\n    @apply tw-text-[#212529];\n  }\n\n  .tw-text-muted {\n    @apply tw-text-[#696973] dark:tw-text-zinc-400;\n  }\n\n  .tw-bg-primary {\n    @apply tw-bg-[#fefefe] dark:tw-bg-[#1a1a1d];\n  }\n\n  .tw-bg-primary-inverted {\n    @apply tw-bg-[#1a1a1d] dark:tw-bg-[#fefefe];\n  }\n\n  .tw-bg-highlight {\n    @apply tw-bg-[#f7f7f7] dark:tw-bg-[#27272a];\n  }\n\n  .tw-bg-highlight-inverted {\n    @apply tw-bg-[#27272a] dark:tw-bg-[#f7f7f7];\n  }\n\n  .tw-bg-striped-light {\n    background-image: linear-gradient(\n      45deg,\n      #f5f5f5 25%,\n      #f0f0f0 25%,\n      #f0f0f0 50%,\n      #f5f5f5 50%,\n      #f5f5f5 75%,\n      #f0f0f0 75%,\n      #f0f0f0 100%\n    );\n    background-size: 56.57px 56.57px;\n  }\n\n  .tw-bg-striped-dark {\n    background-image: linear-gradient(\n      45deg,\n      #2f2f2f 25%,\n      #353535 25%,\n      #353535 50%,\n      #2f2f2f 50%,\n      #2f2f2f 75%,\n      #353535 75%,\n      #353535 100%\n    );\n    background-size: 56.57px 56.57px;\n  }\n\n  .tw-bg-canvas {\n    @apply tw-bg-[#f0f0f0] dark:tw-bg-[#131313];\n  }\n\n  .tw-story-outline {\n    @apply tw-outline tw-outline-2 tw-outline-[#cccccc] dark:tw-outline-[#333333];\n  }\n\n  .tw-link {\n    @apply tw-text-link-blue hover:tw-underline;\n  }\n\n  .tw-youtube-container-portrait {\n    height: max(min(80vh, 700px), 300px);\n  }\n\n  /*\n   * Legacy styling for keyboard highlight bars\n   */\n\n  /* NA = keyboard selection is not applicable */\n  .kb-pad-4-na {\n    @apply tw-border tw-border-solid tw-border-l-[4px] tw-border-l-transparent tw-border-y-0 tw-border-r-0;\n    @apply tw-px-4;\n  }\n\n  .kb-pad-4 {\n    @apply tw-border tw-border-solid tw-border-l-[4px] tw-border-l-transparent tw-border-y-0 tw-border-r-0;\n    @apply tw-px-4;\n  }\n\n  .kb-pad-4.kb-sel {\n    @apply !tw-border-l-perpul-light dark:!tw-border-l-perpul-dark;\n  }\n\n  .kb-bar {\n    @apply tw-border tw-border-solid tw-border-l-[3px] tw-border-l-transparent tw-border-y-0 tw-border-r-0;\n  }\n\n  .kb-bar.kb-sel {\n    @apply !tw-border-l-perpul-light dark:!tw-border-l-perpul-dark;\n  }\n\n  /*\n  * Select styling\n  */\n\n  .tw-select-arrow {\n    background-image: linear-gradient(45deg, transparent 50%, currentcolor 50%),\n      linear-gradient(135deg, currentcolor 50%, transparent 50%);\n    background-position:\n      calc(100% - 20px) calc(1px + 50%),\n      calc(100% - 16px) calc(1px + 50%);\n    background-repeat: no-repeat;\n    background-size:\n      4px 4px,\n      4px 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
